import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PrivacyPortalMenu } from "globalNavigationReact/privacy-portal-menu";
import { useTranslation } from "@monorepo/localization";

export const Navbar = () => {
    const { t } = useTranslation("privacy-portal");
    const location = useLocation();
    const { pathname } = location;
    const navigate = useNavigate();
    const menuItems =
        pathname === "/" || pathname === "/verify-email" || pathname === "/verify-email/"
            ? []
            : [
                  {
                      label: t("Profile and Interests"),
                      href: "./profile-interests",
                      onClick: (e) => {
                          e.preventDefault();
                          navigate("/profile-interests");
                      },
                      isActive: pathname.includes("/profile-interests"),
                  },
                  {
                      label: t("Privacy Settings"),
                      href: "./privacy-settings",
                      onClick: (e) => {
                          e.preventDefault();
                          navigate("/privacy-settings");
                      },
                      isActive: pathname.includes("/privacy-settings"),
                  },
                  {
                      label: t("Communications"),
                      href: "./communications",
                      onClick: (e) => {
                          e.preventDefault();
                          navigate("/communications");
                      },
                      isActive: pathname.includes("/communications"),
                  },
              ];
    return (
        <PrivacyPortalMenu
            data={{
                brand: t("NVIDIA Privacy"),
                menuItems,
            }}
        />
    );
};
